/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2020 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export const namespace = 'canalplus.block.offer.subscription_offer_summary';
export { default as Component } from './containers/SummaryContainer';
export { default as propsFormatter } from './propsFormatter';
